
<template>
  <div class="page">

    <section class="section-block">
      <div class="home-section">
        <Header :onHomePage="true"></Header>
        <div class="title">
          <h1 v-animateonscroll="{ enterClass: 'animation-float-up' }">BLASIO&nbsp;&nbsp;DESIGN<br>STUDIO</h1>
        </div>
        <div class="image-slide" >
          <img v-for="(image, index) in imageSlideArray" :class="{ 'show': currentIndex === index }"
            :src="width > 600 ? image.src : image.srcSmall" :alt="image.alt" :key="index"
            class="home-image" />
        </div>
      </div>
    </section>

    <!-- ------------------------------------------------------- PORRTFOLIO -->
    <section class="section-block">
      <div class="middle home-block">
        <h1 >{{ $t('homepage.titles.portfolio.title') }}</h1>
        <div class="portfolio-images">
          <div class="category" @click="goToFilteredTrigger('familyhouse')">
            <h4>{{ $t('portfolio.filters.familyhouse') }}</h4>
            <img loading="lazy" src="/images/nagy2-small/front_01.jpg" alt="">
            <img loading="lazy" src="/images/Tata_II-small/Tata, Fellner J kül_03.jpg" alt="">
          </div>

          <div class="category" @click="goToFilteredTrigger('factory')">
            <h4>{{ $t('portfolio.filters.factory') }}</h4>
            <img loading="lazy" src="/images/Győr-small/Győr kép2.jpg" alt="">
            <img loading="lazy" src="/images/Komárom II-small/Komárom 2.3.jpg" alt="">
          </div>

          <div class="category" @click="goToFilteredTrigger('public')">
            <h4>{{ $t('portfolio.filters.public') }}</h4>
            <img loading="lazy" src="/images/Komárom tópart-small/Komárom, tópart 2.jpg" alt="">
            <img loading="lazy" src="/images/Szomód-small/Szomód kép2.jpg" alt="">
          </div>

          <div class="category" @click="goToFilteredTrigger('study')">
            <h4>{{ $t('portfolio.filters.study') }}</h4>
            <img loading="lazy" src="/images/nagy2-small/interior_03.jpg" alt="">
            <img loading="lazy" src="/images/Tata_II-small/Tata, Fellner J bel_04.jpg" alt="">
          </div>
        </div>

        <div>
          <div class="middle">
            <router-link to="/portfolio" class="link" v-animateonscroll="{ enterClass: 'animation-float-up' }"
              @click="topPage()">
        <p >{{ $t('homepage.titles.portfolio.link') }}</p>
              <img src="images/icons/arrow_forward_dark.svg" alt="Tovább a Balsio design építésziroda portfóliójára">
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <!-- ------------------------------------------------------- ABOUT US -->
    <section class="section-block">
      <div class="middle home-block">
        <div v-animateonscroll="{ enterClass: 'animation-float-up' }">
        <h1 >{{ $t('homepage.titles.about.title') }}</h1>
        </div>
        <div class="middle about-block">
          <div class="about-text" v-animateonscroll="{ enterClass: 'animation-float-up' }">
            <!-- <h2>Lorem ipsum dolor sit amet consectetur.</h2> -->
            <p>{{ $t('homepage.titles.about.description') }}</p>
          </div>
          <img @contextmenu.prevent class="video" src="images/sematikus_alaprajz.jpg" v-animateonscroll="{ enterClass: 'animation-float-up' }" />
        </div>



        <router-link to="/about" class="link" v-animateonscroll="{ enterClass: 'animation-float-up' }"
          @click="topPage()">
        <p >{{ $t('homepage.titles.about.link') }}</p>
          <img src="images/icons/arrow_forward_dark.svg" alt="">
        </router-link>
      </div>
    </section>
    <!-- ------------------------------------------------------- TEAM -->
    <section class="section-block">
      <div class="middle home-block">
        <div v-animateonscroll="{ enterClass: 'animation-float-up' }">
        <h1 >{{ $t('homepage.titles.team.title') }}</h1>
        </div>
        <div v-animateonscroll="{ enterClass: 'animation-float-up' }" class="team-block">
          <div class="team-member-block">
            <div>

                <img class="team-member" src="images/portraits/BB.jpg" alt="Bencsik Balázs - okleveles tervező építészmérnök, vezető tervező">

              <div class="team-member-name">
                <p>Bencsik Balázs</p>
              </div>
              <div class="team-member-position">
                <h6>okleveles tervező építészmérnök</h6>
                <h6>vezető tervező</h6>
              </div>
            </div>

            <div>

                <img class="team-member" src="images/portraits/HTJ.jpg" alt="Haász-Tamás Judit - építészmérnök, szerkesztő-tervező">
              
              <div class="team-member-name">
                <p>Haász-Tamás Judit</p>
              </div>
              <div class="team-member-position">
                <h6>építészmérnök, szerkesztő-tervező</h6>
              </div>
            </div>
          </div>
          <div class="team-member-block">
            <div>

                <img class="team-member" src="images/portraits/JB.jpg" alt="Joó Bence - építészmérnök, szerkesztő-tervező">
     
              <div class="team-member-name">
                <p>Joó Bence</p>
              </div>
              <div class="team-member-position">
                <h6>építészmérnök, szerkesztő-tervező</h6>
              </div>
            </div>

            <div>

                <img class="team-member" src="images/portraits/SZM.jpg" alt="Szemerei Mónika - építészmérnök, szerkesztő-tervező">

              <div class="team-member-name">
                <p>Szemerei Mónika</p>
              </div>
              <div class="team-member-position">
                <h6>építészmérnök, szerkesztő-tervező</h6>
              </div>
            </div>
          </div>
        </div>


        <router-link v-animateonscroll="{ enterClass: 'animation-float-up' }" to="/team" class="link"
          @click="topPage()">
        <p >{{ $t('homepage.titles.team.link') }}</p>
          <img src="images/icons/arrow_forward_dark.svg" alt="">
        </router-link>
      </div>
    </section>
    <!-- ------------------------------------------------------- CONTACT -->
    <section class="section-block">
      <div class="middle home-block">
        <div v-animateonscroll="{ enterClass: 'animation-float-up' }">
        <h1 >{{ $t('homepage.titles.contact.title') }}</h1>
        </div>

        <div class="contact-block">
          <div v-animateonscroll="{ enterClass: 'animation-float-up' }">
            <img class="map" src="images/map.jpg" alt="A tervező iroda komáromi elhelyezkedése">
          </div>
          <div class="contacts">
            <div class="contact" @click="writeClipboardText('+36 30 123 4567')"
              v-animateonscroll="{ enterClass: 'animation-float-up' }" v-tooltip.top="$t('contact.copy')">
              <img class="contact-icon" src="/images/icons/phone.svg" alt="A tervező iroda telefonszáma">
              <span>+36 70 881 9393</span>
            </div>

            <div class="contact" @click="writeClipboardText('blasio.design@gmail.com')"
              v-animateonscroll="{ enterClass: 'animation-float-up' }" v-tooltip.top="$t('contact.copy')">
              <img class="contact-icon" src="/images/icons/mail.svg" alt="A tervező oldal e-mail címe">
              <span>iroda@blasio.hu</span>
            </div>

            <div class="contact" @click="writeClipboardText('2900 Komárom, Klapka utca 256.')"
              v-animateonscroll="{ enterClass: 'animation-float-up' }"
              v-tooltip.top="$t('contact.copy')">
              <img class="contact-icon" src="/images/icons/location.svg" alt="A tervező iroda címe">
              <span>2900 Komárom, Klapka György út 20-22.</span>
            </div>
          </div>
        </div>

      </div>

    </section>
    <section class="footer-section">
      <Footer></Footer>
    </section>
  </div>
</template>

<script setup>
import Header from '@/components/page_controlls/Header.vue';
import Footer from '@/components/page_controlls/Footer.vue';
import { ref, onMounted, watchEffect } from 'vue';
import { useDataStore } from '@/store';
import 'intersection-observer';
import { useToast } from "vue-toastification";
import router from '@/router';

const toast = useToast();
const store = useDataStore();

const images = ref([]);
const width = ref(window.innerWidth);

const imageSlideArray = ref([
  { "src": "images/nagy2/nagyterasz_01.jpg", "srcSmall": "images/nagy2-small/nagyterasz_01.jpg", "alt": "Családi ház tervezés látványterv 1" },
  { "src": "images/nagy2/nagyterasz_05.jpg", "srcSmall": "images/nagy2-small/nagyterasz_05.jpg", "alt": "Családi ház tervezés látványterv 2" },
  { "src": "images/Tata_II/Tata, Fellner J kül_03.jpg", "srcSmall": "images/Tata_II-small/Tata, Fellner J kül_03.jpg", "alt": "Családi ház tervezés látványterv 3" },
  { "src": "images/Tata_II/Tata, Fellner J kül_06.jpg", "srcSmall": "images/Tata_II-small/Tata, Fellner J kül_06.jpg", "alt": "Családi ház tervezés látványterv 4" }
]);


const currentIndex = ref(0);
const startSlider = () => {
  setInterval(() => {
    currentIndex.value++;
    if (currentIndex.value >= imageSlideArray.value.length) {
      currentIndex.value = 0;
    }
  }, 4000);
};


function goToFilteredTrigger(filter) {
  router.push(filter === 'all' ? '/portfolio' : `/portfolio/${filter}`)
  topPage();
}

onMounted(async () => {
  startSlider();
  await store.fetchImages(); 
});

addEventListener('resize', () => {
  width.value = window.innerWidth;
})

onresize = () => {
  width.value = window.innerWidth;
};

function topPage() {
  window.scrollTo({
    top: 0
  });
}

function writeClipboardText(text) {
  navigator.clipboard.writeText(text)
  toast.success(t('contact.copied'))
}


</script>


<style lang="css" scoped>
.section-block {
  height: 100%;
  margin-bottom: 160px;
}

.footer-section {
  scroll-snap-align: end;
}

.home-section {
  top: 0;
  left: 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 0;
}


.image-slide {
  display: flex;
  box-shadow: #282828 0px 0px 10px;
}

.home-image {
  opacity: 0;
  position: absolute;
  transition: opacity 2s ease-in-out;
  width: 100vw;
  z-index: -10;
  filter: brightness(0.5) contrast(1.2);
  object-fit: cover;
  object-position: center;
  aspect-ratio: 16/9;
}

.home-image.show {
  opacity: 1;
  position: static;
  transition: 1s ease-in-out;

}


h1,
h2,
p {
  color: #282828;
}


.title {
  position: absolute;
  z-index: 1;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.title h1 {

  font-weight: 400;
  margin: 0;
  letter-spacing: 0.5vw;
  color: #f5f5f5;
  text-align: center;
}

.home-block {
  flex-direction: column;
  /* margin: 150px 0; */
}

.portfolio-images {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.category {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 10px;

  cursor: pointer;
  font-size: 1.3vw;
  font-weight: 500;
  color: #282828;
  font-variant: small-caps;
}

.category img {
  aspect-ratio: 4/3;
  width: 20vw;
  transform: scale(1);
  transition: transform 0.2s ease-in-out;
  object-fit: cover;
}

.category h4:hover {
  color: #727272;
}

.category img:hover {
  transform: scale(1.03);
  transition: transform 0.2s ease-in-out;
}

.home-block .link {
  display: flex;
  gap: 6px;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  text-decoration: none;
  color: #282828;
  margin-top: 24px;
}

.home-block .link p {
  margin: 0;
  transition: 200ms ease-in-out;
}

.home-block .link:hover p {
  transition: 200ms ease-in-out;
  font-weight: 500;
}

.home-block .link:hover img {
  transition: 300ms ease-in-out;
  transform: scale(1.1);
}

.home-block .link img {
  margin-top: 4px;
}

.about-block {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 100px;
}

.about-block .about-text {
  width: 35vw;
  text-align: justify;
}

.about-block .video {
  width: 25vw;
  /* aspect-ratio: 16/9; */
  height: auto;
  background-color: #ccc;
}

.team-block {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: start;
  flex-wrap: wrap;
  gap: 4vw;
  margin: 0 30px;
}

.team-member {
  width: 20vw;
  min-width: 150px;
  aspect-ratio: 3/4;
  height: auto;
}

.team-member-name p,
.team-member-position h6 {
  margin: 0;
}

.team-member-block {
  display: flex;
  flex-direction: row;
  gap: 4vw;
}

.contact-block {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 40px;

}

.contact-block .map {
  width: 40vw;
}

.contacts {
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 120px;
  height: 100%;
}

.contact {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.contact span {
  font-size: 18px;
  margin: 0;
}

.contact-icon {
  width: 32px;
  height: 32px;
}



@media only screen and (min-width: 1696px) {

  .home-image,
  .home-image.show {
    width: 100%;
    height: 100%;
  }

}


@media only screen and (max-width: 1470px) {
  .portfolio-images {
    margin: 0 20px;
  }

  .portfolio-images img {
    width: 22vw;
  }

}


@media only screen and (max-width: 1200px) {
  h2 {
    font-size: 36px;
  }

  p {
    font-size: 18px;
  }

  .contacts {
    gap: 100px;
  }

  .contact-icon {
    width: 28px;
    height: 28px;
  }

  .portfolio-images img {
    width: 400px;
  }

}



@media only screen and (max-width: 1000px) {
  h1 {
    font-size: 72px;
  }

  .section-block {
    margin-bottom: 120px;
  }

  .contacts {
    gap: 80px;
  }

  .contact-icon {
    width: 24px;
    height: 24px;
  }


  .category h4 {
    font-size: 3vw;
  }

}


@media only screen and (max-width: 800px) {
  h2 {
    font-size: 28px;
    margin: 12px 0;
  }

  p {
    font-size: 14px;
  }

  .image-slide {
    height: 100vh;
    width: auto;

  }

  .home-image {
    height: 100vh;
  }


  .category h4 {
    font-size: 4vw;
  }

  .section-block {
    margin-bottom: 100px;
  }

  .portfolio-images img {
    width: 280px;
  }

  .about-block {
    flex-direction: column;
    gap: 20px;
  }

  .about-block .about-text {
    width: 80vw;
  }

  .about-block .video {
    width: 60vw;
    height: auto;
    /* aspect-ratio: 9/16; */
    height: auto;
    background-color: #ccc;
  }


  .contact-block .map {
    width: 70vw;
  }

  .contact-block {
    flex-direction: column;
  }

  .contacts {
    gap: 20px;
    align-items: start;
  }

  .contact {
    flex-direction: row;

  }

  .team-member {
    width: 150px;
  }

}


@media only screen and (max-width: 660px) {

  h1 {
    font-size: 48px;
  }

  .portfolio-images img {
    width: 85vw;
  }

}


.slide-fade-enter-active {
  transition: all 0.8s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(40px);
  opacity: 0;
}
</style>
